/* eslint-disable no-unused-vars,no-unused-vars,no-undef */
import axios from 'axios'
import QS from 'qs'
import changeRequestUrl from './urlGroupMap'

import {Indicator, Toast} from 'mint-ui'
// 不注释 项目代码报错---todo
// import '@/libs/global'
import utils from "../utils/utils";
import getJwtSafeCode from '@/libs/http/jwt.js'

// 默认超时配置
axios.defaults.timeout = 20000
var root = process.env.API_ROOT
//如果是测试环境,baseUrl改成域名地址
console.log(process.env.NODE_ENV, 666);
if (process.env.NODE_ENV === 'dev') {
    // root = location.origin + '/backendapi'
    root = 'https://test-app5.shouqiev.com/backendapi'
}
if (process.env.NODE_ENV === 'testing') {
    if (location.href.indexOf('localhost') > -1) {
        root = process.env.API_ROOT
    } else {
        root = location.origin
    }
}
if (process.env.NODE_ENV !== 'testing' && top.h5car) {
    root = process.env.API_ROOT_H5CAR
}
if (location.origin === 'https://c2c.shouqiev.com') {
    root = process.env.API_ROOT_C2C
}
if (location.origin === 'https://autopilot.shouqiev.com') {
    root = process.env.API_ROOT_Autopilot
}
if (location.origin === 'http://app410.51gofunev.com' ||
    location.origin === 'http://app420.51gofunev.com' ||
    location.origin === 'http://app430.51gofunev.com' ||
    location.origin === 'http://app520.51gofunev.com' ||
    location.origin === 'http://app530.51gofunev.com' ||
    location.origin === 'https://app410.51gofunev.com' ||
    location.origin === 'https://app420.51gofunev.com' ||
    location.origin === 'https://app430.51gofunev.com' ||
    location.origin === 'https://app510.51gofunev.com' ||
    location.origin === 'https://app520.51gofunev.com' ||
    location.origin === 'https://app530.51gofunev.com' ||
    location.origin === 'https://app5share10.51gofunev.com' ||
    location.origin === 'https://app5share20.51gofunev.com' ||
    location.origin === 'https://app5share30.51gofunev.com' ||
    location.origin === 'https://preapp4.shouqiev.com' ||
    location.origin === 'https://preapp5.shouqiev.com' ||
    location.origin === 'https://preapp5share.shouqiev.com' ||
    location.origin === 'https://app4.shouqiev.com' ||
    location.origin === 'https://app5.shouqiev.com' ||
    location.origin === 'https://app5share.shouqiev.com' ||
    location.origin === 'https://app5share1.shouqiev.com' ||
    location.origin === 'https://app5share2.shouqiev.com' ||
    location.origin === 'https://app5share3.shouqiev.com' ||
    location.origin === 'https://app5share4.shouqiev.com' ||
    location.origin === 'https://app5share5.shouqiev.com' ||
    location.origin === 'https://test-app5.shouqiev.com' ||
    location.origin === 'http://test-app5.shouqiev.com'
) {
    root = location.origin + '/backendapi'
}
console.log(root, 'rootroot')
// 默认请求域名
axios.defaults.baseURL = root

// 跨域是否自定携带cookies
// axios.defaults.withCredentials = true;

// 格式化参数
axios.defaults.transformRequest = [
    function (data) {
        data = QS.stringify(data)
        return data
    },
]

// http request 拦截器
axios.interceptors.request.use(
    (config) => {
        //接口分组方法
        changeRequestUrl(config)

        //如果有withoutGateWay，表示调用不带网关的地址
        if (config.withoutGateWay) {
            config.baseURL = process.env.API_ROOT_WITHOUT_GATEWAY
        }

        // 默认使用loading图，如果不需要loading图，需传参noLoading:true
        if (!config.noLoading) {
            Indicator.open()
        }

        // 获取jwt
        var jwt = getJwtSafeCode()
        // console.log('====== jwt ======,', jwt)
        //config.dataReport 表示是埋点的请求
        if (config.dataReport) {
            config.headers.source = 'h5'
            config.headers['Content-Type'] = 'application/json'
            config.transformRequest = function (data) {
                return JSON.stringify(data)
            }
        } else {
            //普通接口调用
            let token = utils.getToken(config.isGofunSelect);
            // let token = '673b39639a6e9282c72a243fd965a5d4';
            // console.log('header token:', token);
            config.headers = {
                'GOFUNAUTHORIZATION': token,
                'AUTHORIZATION': jwt,
                ...config.headers,
            }
            //requestJson 后台需要json格式请求
            if (config.requestJson) {
                config.headers['Content-Type'] = 'application/json'
                config.transformRequest = function (data) {
                    return JSON.stringify(data)
                }
            }
			if (config.requestFormData) {
				config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
			}
            //开发环境调用接口默认传token参数
            // if (process.env.NODE_ENV === 'dev') {
            //   console.log(config.params)
            // }
            //正常请求
            if (config.requestJson) {
                config.headers['Content-Type'] = 'application/json'
            }
			if (config.noHeader) {
				config.headers = null
			}
        }
        return config
    },
    (err) => {
        return Promise.reject(err)
    })

// http response 拦截器
axios.interceptors.response.use(
    (response) => {
        //除去 200成功状态 和 190808网关降级状态的 code码，其他都当失败处理，会toast错误说明
        if (!response.config.noToast && response.data && response.data.code &&
            (response.data.code !== 200 && response.data.code !== 190808)) {
            Toast(response.data.desc || response.data.message)
        }
        Indicator.close()
        return response
    },
    (error) => {
        Indicator.close()
        if (error.config && error.config.headers && !error.config.dataReport &&
            !error.config.headers.AUTHORIZATION) {
            Toast('系统出了点小问题，请退出重试')
        }
        // Toast('请求出错')
        return Promise.reject(error)
    })

export default axios



// WEBPACK FOOTER //
// src/libs/http/axios.js